export default __webpack_public_path__ + "check.c623810834bfc603.svg";